<template>
<div class="live-item" v-if="data.type === 1 || (isTeacher && data.type === 2 && data.status === 0) || (data.type === 2 && data.status === 1) || data.type === 3 || data.type === 4 || data.type === 5 || data.type === 7 || data.type === 9 || data.type === 10 || data.type === 12">
  <!--
    消息类型：
    1、老师发言
    2、问答
    3、投票
    4、送礼
    5、系统推送
    7、藏金阁
    9、博文
    10、付费观点
    12、特训班推送
  -->
  <div :data-id="data.id" v-if="data.type === 1 || (data.type === 2 && data.body) || data.type === 3 || data.type === 4 || data.type === 5 || data.type === 7 || data.type === 9 || data.type === 12" :class="bgColor">
    <div class="item-author-wrap clearfix">
      <!--系统推送头部-->
      <div class="item-system" v-if="data.type === 5">
        <div class="system-left left">
          <p><i class="iconfont icon-xitonggonggao"></i> <em>系统公告</em></p>
          <!-- <span class="iconspan"></span> -->
        </div>
        <div class="system-right yf-text_14 left">{{ data.createdAt }}</div>
      </div>

      <!--老师推送头部-->
      <div v-else class="live-item-author">
        <div class="img-wrap left">
          <img v-lazy="isSupportWebp(data.userAvatar)" alt="data.userName" />
          <span class="iconspan"></span>
        </div>
        <div class="person-name left">
          <p>
            <span><i class="iconfont icon-sf" :class="`yf-user-type_${data.userType}`" :title="identity(data.userType)"></i> {{ data.userName }}</span>
            <span class="teacher_time"> {{ data.createdAt }}</span>
          </p>
        </div>
        <div v-show="data.type == 1 || data.type === 10" class="item-active right">
          <a @mouseover="shareshow = true" @mouseleave="shareshow = false">分享</a>
          <div @mouseover="shareshow = true" @mouseleave="shareshow = false" class="share_wrap" v-show="shareshow">
            <section>
              <span>分享到：</span>
              <ul>
                <li v-for="item of shareList" :key="item">
                  <img @click="ShareModelShow(item, $event)" v-lazy="`http://static.bshare.cn/frame/images/logos/mp2/${item}.gif`" alt="分享图标" />
                </li>
                <li><a @click="ShareModelShow('more', $event)"> >> </a></li>
              </ul>
            </section>
          </div>
          <span @click="handleZan">点赞<i>{{ zan }}</i></span>
        </div>
      </div>
    </div>
    <!--内容部分-->
    <div :id="`viewpoint_${data.id}`" ref="inner" class="item-inner">
      <div>
        <!-- 普通发言 -->
        <div v-if="data.type === 1 && !data.quoteId">
          <div>
            <div class="item-inner-text rich_text" v-html="switchBody(data.content)"></div>
          </div>
        </div>

        <!-- 引用发言 -->
        <div v-else-if="data.type === 1 && data.quoteId > 0" class="inner-wrap">
          <div class="wrap-top">
            <div class="title">
              <p class="left">
                <i class="iconfont icon-sf" :class="`yf-user-type_${data.quoteUserType}`"></i>
                {{ data.quoteUserName }}
              </p>
              <p class="right">{{ data.quoteCreateAt }}</p>
            </div>
            <div class="detail rich_text" v-html="switchBody(data.quoteContent)"></div>
          </div>
          <div class="rich_text" v-html="switchBody(data.content)"></div>
        </div>

        <!-- 问答内容 -->
        <div v-else-if="data.type === 2 && data.status === 1">
          <p class="link">{{ data.answerName }} 回答了<span>{{ data.userName }}</span>的提问 <nuxt-link :to="`/question/detail/${data.relationId}`" target="_blank" rel="noopener">点击查看详情 >></nuxt-link></p>
        </div>
        <div v-else-if="data.type === 2 && data.status === 0 && isTeacher">
          <p class="link"><span>{{ data.userName }}</span> 正在向您提问 <nuxt-link :to="`/question/detail/${data.relationId}`" target="_blank" rel="noopener">点击查看详情 >></nuxt-link></p>
        </div>
        <!-- 投票 -->
        <div v-else-if="data.type === 3" class="vote"><span>+{{ data.num }}</span>给{{ data.teacherName }}投了 <span>{{ data.num }}</span> 票，感谢支持！</div>
        <!-- 送礼物 -->
        <div v-else-if="data.type === 4" class="gift">
          <p><img v-lazy="data.giftUrl" :alt="data.giftName" />送给{{ data.teacherName }} <span>{{ data.giftName }}</span>，感谢支持！</p>
        </div>
        <!-- 系统公告 -->
        <div v-else-if="data.type === 5" class="system-inner">
          <div v-html="data.content"></div>
        </div>
        <!-- 文章 -->
        <div v-else-if="data.type === 7">
          <p class="link" :class="[ data.articleType === 1 ? 'cjg' : 'bowen' ]"><i class="iconfont" :class="[ data.articleType === 1 ? 'cjg icon-cjg' : 'bowen icon-wenzhang' ]"></i> {{ data.userName }} {{ data | filter }}，<nuxt-link :to="`/article/detail/${data.relationId}`" target="_blank" rel="noopener">点击查看详情 >></nuxt-link></p>
        </div>
        <!-- 特训班推送 -->
        <div v-else-if="data.type === 12" class="tip-msg">
          <p><i class="iconfont icon-txb"></i> {{ data.userNickName }}在<span>【特训班】</span>发布了新消息，<nuxt-link target="_blank" rel="noopener" :to="`/vip/room/${data.relationId}`">立即查看>></nuxt-link></p>
        </div>
      </div>
    </div>
  </div>

  <!--加密观点内容部分-->
  <encrypted-view :data-id="data.id" v-else-if="data.type === 10" :data="$store.getters['room/getEncryptedViewData'](data.relationId)"></encrypted-view>
</div>

</template>

<script>
import { switchBody, identity } from '@/utils/Filters'
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'
import EncryptedView from '@/components/room/EncryptedView'

export default {
  mixins: [Webp],
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
    	shareshow: false,
    	shareList: ['sinaminiblog', 'qqim', 'qzone', 'itieba', 'tianya', 'douban'],
      zan: this.data.zan,
      isZan: this.data.isZan || false
    }
  },
  mounted () {
    if (this.$refs.inner) {
      let imgs = this.$refs.inner.querySelectorAll('img')
      for (let img of imgs) {
        // 绑定加载完成事件
        img.onload = () => {
          this.$emit('imgLoad')
        }
        if (!/^http:\/\/staticres/.test(img.src)) {
          img.classList.add('js-ubb-img-in')
          // 绑定图片放大事件
          img.onclick = () => {
            let origin = img.getAttribute('src');
            if (origin) {
              this.$emit('showImg', origin)
            }
          }
        }
      }
    }
  },
  methods: {
    handleZan () {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      if (!this.isZan) {
        this.$axios._post('/Room/Zan', { id: this.data.id }).then(_ => {
          this.zan++
          this.isZan = true
        })
      }
    },
    // bShare分享
    ShareModelShow (action, event) {
      let summary = this.data.content
      summary = summary.replace(/<\/?[^>]*>/g, '').replace(" ","").replace(/\n[\s| | ]*\r/g, '\n').replace(/&nbsp;/ig, '')
	    const model = {
        title: document.title,
        url: window.location.href,
        summary
      }
	    if (action === 'more') {
	      bShare.more(event, model)
	    } else {
	      bShare.share(event, action, model)
	    }
    },
    // 显示身份
    identity,
    switchBody
  },
  filters: {
    filter (item) {
      switch (item.articleType) {
        case 1:
          return item.status === 2 ? '追加藏金阁' + `《${item.title}》` : '新增藏金阁' + `《${item.createdAt.slice(0, 11) + item.title}》`
        case 2:
          return '发表了付费文章' + `《${item.title}》`
        case 3:
          return '发表了免费文章' + `《${item.title}》`
      }
    }
  },
  // 计算属性判断是否显示
  computed: {
    bgColor () {
      switch (this.data.type) {
        case 2:
          return 'wenda'
        case 7:
          return this.data.articleType === 1 ? 'cjg' : 'bw'
        case 9:
          return 'bw'
      }
    },
    isTeacher () {
      return this.$store.getters['room/isTeacher']
    }
  },
  components:{
    EncryptedView
  }
}
</script>

<style lang="less" scoped>
.live-item {
  border-bottom: 1px solid #eee; margin: 0 30px; padding-bottom: 10px;
  .live-item-author { height: 66px; padding-top: 15px;
    .img-wrap { width: 50px; text-align:center;
      img { width: 40px; height: 40px; border-radius: 50%; }
      .iconspan { display: block;  width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #fff; margin: 0 auto; }
    }
    .person-name { width: 350px;
      p { height: 22px; margin-top: 10px; margin-left: 4px; text-indent: 2px; font-size: 16px;
        img {vertical-align: -8%; padding-left: 2px; padding-right: 2px;}
        .teacher_time { color: #999; font-size: 14px;}
      }
    }
    .item-active {
      float: right; padding-top: 11px;
      & > a,& > span {
        padding: 2px 10px; border: 1px solid #5c9bea; color: #5c9bea; cursor: pointer; border-radius: 2px;
        &:hover { color: #e7735a; border-color: #e7735a; }
      }
      & > span { margin-left: 10px;
        i { color: #e7735a; padding-left: 4px; }
      }
    }
  }
  .item-system {
    .system-left { width: 160px; padding-top: 17px;
      > .iconspan {
        display: block;  width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid red; margin: 0 auto; margin-top: 8px; margin-left: 35px;
      }
      > p { height: 40px;  background: #e43a3d; border-radius: 25px; line-height: 40px; color: #fff;  margin-right: 10px;
        > i { vertical-align: -13%; font-size: 30px; margin-left: 5px;}
        > em { margin-left: 12px;  font-size: 16px;}
      }
    }
    .system-right { line-height: 72px; color: #9a9a9a; }
  }
  .item-inner { background: #fff; border-radius: 4px;
    > p { line-height:24px; }
    .inner-wrap {
      .wrap-top { background: #f0f0f8; padding:10px 18px; border-radius: 4px;
        .title { height: 26px;
          p:nth-child(1) { width: 160px; font-size: 14px; color: #5c9bea; }
          p:nth-child(2) { width: 150px; text-align: right; color: #888; }
        }
        .detail { line-height: 24px; word-break: break-all; font-size: 14px; color: #666;}
      }
      > .rich_text { line-height: 24px; font-size: 16px; padding-top: 10px;}
    }
    .link { font-size: 15px; padding: 10px 15px;
      > .cjg,> .bowen { border-radius: 50%; vertical-align: middle; color: #fff; margin-right: 10px; }
      > .cjg { font-size: 26px;  background: #ffa921; padding: 0 2px;}
      a { color: #e43a3d; font-size: 15px;}
      > .bowen { font-size: 19px; background: #85a5e0; padding: 4px 4px;}
    }
    .system-inner { height: 100%; font-size: 14px;
      > p { line-height: 24px; padding-top: 10px; }
    }
  }
}
.cjg {
  .item-inner { background: #fdedb4 !important;line-height: 30px !important;}
  .iconspan  { border-bottom-color: #fdedb4 !important;}
}
.bw {
  .item-inner { background: #e2eefc !important;line-height: 30px !important;}
  .iconspan  { border-bottom-color: #e2eefc !important;}
}
.item-inner1 { background: #F9F9F9 !important;
  .link { height: 30px; line-height: 30px;}
}
.iconspan1 { border-bottom:8px solid #F9F9F9!important; }
.item-inner9 { background: #E6F0FC !important;
	.link { height: 30px; line-height: 30px;}
}
.iconspan9 { border-bottom:8px solid #E6F0FC!important;}
.item-active { position: relative;
	.share_wrap {
    position: absolute; top: 30px; right: -20px; padding-top: 10px;
    section {
      width: 332px; height: 54px; padding-left: 10px; line-height: 54px; border: 1px solid #C5C5C5; box-shadow: 0px 1px 2px #333; background: #FFFFFF;
      span {float: left; font-size: 14px; color: #666666;}
      ul {
        overflow: hidden; padding-top: 5px; margin-left: 5px;
        li { float: left; cursor: pointer; margin-left: 9px; width: 22px; height: 40px;
          img { width: 22px; height: 22px; }
        }
        li:nth-last-child(1) { line-height: 40px;}
      }
    }
  }
}
.wenda {
  .item-inner { background: #f0e6e5 !important;line-height: 30px !important; }
  .iconspan { border-bottom-color: #f0e6e5 !important;}
}
.gift { background: #fdd9e7; border-radius: 3px;
  &:before { border-color: transparent transparent #fdd9e7; }
  p { padding:10px 20px; font-size: 16px; color: #666; font-weight: 900;
    img { vertical-align: middle; margin-right: 10px;}
    span { color: #e43a3d; font-size: 16px; }
  }
}
.vote { background: #eae8fe; padding: 10px 20px; border-radius: 4px; font-size: 16px; color: #696367; font-weight: 900;
  &:before { border-color: transparent transparent #e8e8ff; }
  span:first-child {color: #e6393d; font-size: 30px; margin-right: 15px; vertical-align: -10%; }
  span:last-child { color: #e6393d; }
}
.tip-msg { background: #8f62af; padding: 16px 20px 12px; border-radius: 4px; font-size: 16px; color: #fff;
  &:before { border-color: transparent transparent #8f62af; }
  i { background-color: #ffab34; color: #fff; font-size: 20px; display: inline-block; padding: 5px 6px 3px; border-radius: 50%; vertical-align: -10%; margin-right: 10px; }
  span,a { color: #fed652; }
}
.gift,.vote,.tip-msg { position: relative;
  &:before { content: " "; display: block; width: 0; height: 0; border-width: 8px; border-style: solid; position: absolute; left: 17px; top: -16px; }
}
</style>
